__turbopack_context__.v({
  "smallButton": "button-module-scss-module__d5QlGa__smallButton",
});
